var request = require('superagent'),
	_ = require('underscore'),
	Q = require('q'),
	utilities = require('utilities'),
	abortify = require('async/abortify'),
	AbortionError = require('core/errors/AbortionError');

var requestsOngoing = 0,
	$body = $('body');

var RETRY_DELAY = 5000;

window.networkLog = [];

const ERR_WHITE_LIST = {
	'/v2/analytix/events': true,
	'/v2/analytix/timestamp': true
};

function requester(method, url, data, headers) {
	let deferred = Q.defer();
	let superAgentRequest = request[method].call(request, url);
	let networkTimer = 0;
	let networkItem = null;

	if (data) {
		if (method === 'get') {
			superAgentRequest = superAgentRequest.query(data).send();
		} else {
			superAgentRequest = superAgentRequest.send(data);
		}
	}

	if (headers) {
		for (var key in headers) {
			var value = headers[key];

			if (typeof value !== 'undefined' && value !== null) {
				superAgentRequest.set(key, value);
			}
		}
	}

	superAgentRequest.once('abort', function () {
		deferred.reject(new AbortionError());
	});

	if (requestsOngoing++ === 0) {
		$body.addClass('requests-ongoing');
	}

	var args = arguments;

	superAgentRequest.end(function (err, res) {
		superAgentRequest.removeAllListeners('abort');

		if (err && err.crossDomain) {
			// There is no way to differentiate between a CORS error and lack of internet connectivity
			// So if the request origin is the same as the site's main origin, we'll assume this is actually a connectivity issue
			if ((superAgentRequest.url[0] === '/' && superAgentRequest.url[1] !== '/') || superAgentRequest.url.indexOf(location.origin) === 0) {
				err.crossDomain = false;
			}
		}

		if (window.readworks.config.rwtesting) {
			if (networkItem && res) {
				// networkItem.res = res.body;
				networkItem.status = res.status;
			}
			if (!res || (res && res.status !== 200)) {
				let body = (err && err.response && err.response.body) || (res && res.body) || err || {};
				let testSuite = localStorage.rwTestSuite;
				let errorExceptions = window.readworks.config.serviceErrorExceptions || {};
				let rejection = _.extend(networkItem, body, {
					status: res && res.status
				});
				let code = rejection.code;

				if (testSuite && testSuite.indexOf('/') !== -1) {
					testSuite = testSuite.replace(/\//, '');
				}

				if (!testSuite || !code || !errorExceptions[testSuite] || !errorExceptions[testSuite][code]) {
					throw new Error('Service call was not successful: ' + JSON.stringify(rejection));
				}
			}
		}
		if (res && res.status === 200) {
			deferred.resolve(res);
		} else if (!res && (!err || !err.crossDomain) && !ERR_WHITE_LIST[url]) {
			utilities.openModal('#no-internet-connection', {
				keepOthers: true
			});

			setTimeout(function () {
				requester.apply(this, args).then(deferred.resolve, deferred.reject);
			}, RETRY_DELAY);
		} else if (!res && (!err || !err.crossDomain) && ERR_WHITE_LIST[url]) {
			let squelchErrorResponse = { headers: {} };
			deferred.resolve(squelchErrorResponse);
		} else if (res && (res.status === 502 || res.status === 503 || res.status === 504)) {
			utilities.openModal('#server-down', {
				keepOthers: true
			});

			setTimeout(function () {
				requester.apply(this, args).then(deferred.resolve, deferred.reject);
			}, RETRY_DELAY);
		} else {
			let body = (err && err.response && err.response.body) || (res && res.body) || err || {};
			let rejection = _.extend({}, body, {
				status: res && res.status
			});

			if (networkItem && body) {
				// networkItem.res = body;
				networkItem.status = res && res.status;
			}

			deferred.reject(rejection);
		}
	});

	if (window.readworks.config.rwtesting) {
		networkItem = {
			url,
			data
		};
		window.networkLog.push(networkItem);
		networkTimer = Date.now();
	}

	return abortify(
		deferred.promise.fin(function () {
			if (--requestsOngoing === 0) {
				$body.removeClass('requests-ongoing');
				utilities.closeModals('#no-internet-connection').closeModals('#server-down');
			}

			if (window.readworks.config.rwtesting) {
				networkItem.time = Date.now() - networkTimer;
				networkItem = null;
				networkTimer = null;
			}
		})
	).onAbort(superAgentRequest.abort.bind(superAgentRequest));
}

module.exports = {
	get: function (url, data, headers) {
		return requester('get', url, data, headers);
	},

	post: function (url, data, headers) {
		return requester('post', url, data, headers);
	},

	put: function (url, data, headers) {
		return requester('put', url, data, headers);
	},

	del: function (url, data, headers) {
		return requester('del', url, data, headers);
	}
};
